import React, { useEffect, useMemo, useRef, useState } from 'react';
import { fetchOverlapSteamGamesRanks } from '@intelligence/services/overlapAnalysis';
import {
  OVERLAP_STEAM_METRICPARAMS,
  OVERLAP_STEAM_ORDERMETRIC,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/constants/metrics';
import Tables from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/components/Tables';
import { SortByItemType } from '@intelligence/components/TableComponents/components/SortBy';
import { PagingQuery } from 'tea-component';
import classNames from 'classnames';
import './index.scss';

const TableService = (props: any) => {
  const {
    filterVal,
    className,
    style,
    gameInfoLoading,
    segmentKey = 'played_play',
    onTagClick,
    onTableLoadingChange,
  } = props || {};

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [params, setParams] = useState<any>(() => ({ ...(filterVal || {}) }));
  const requestIdRef = useRef(0);

  // 上报 loading 状态给父组件，用于筛选器防频繁切换
  useEffect(() => {
    onTableLoadingChange?.(loading);
  }, [loading]);

  const newParams = useMemo(
    () => ({
      order_metric: OVERLAP_STEAM_ORDERMETRIC[segmentKey],
      ...params,
      // 确保指标不会被覆盖
      metrics: OVERLAP_STEAM_METRICPARAMS[segmentKey],
    }),
    [params, segmentKey],
  );

  useEffect(() => {
    if (gameInfoLoading) return;
    getData();
  }, [newParams, gameInfoLoading]);

  useEffect(() => {
    if (!filterVal) return;
    setParams({ ...filterVal });
  }, [filterVal]);

  const getData = () => {
    const currentRequestId = requestIdRef.current + 1;
    requestIdRef.current = currentRequestId;
    setLoading(true);
    setData([]);
    setTotal(0);
    // 添加overlapSteamGamesRanks接口参数兜底
    if (newParams?.id !== '' && newParams?.engagement_level_a && newParams?.engagement_level_b) {
      fetchOverlapSteamGamesRanks({
        ...newParams,
      })
        .then((res) => {
          if (currentRequestId !== requestIdRef.current) return;
          const { data = {} as any } = res || {};
          const { total = 0, rank_list: rankList = [] } = data;
          setTotal(total || rankList?.length);
          setData(rankList || []);
        })
        .catch((err) => {
          if (currentRequestId !== requestIdRef.current) return;
          console.log('🚀 ~ TableService ~ err:', err);
        })
        .finally(() => {
          if (currentRequestId === requestIdRef.current) {
            setLoading(false);
          }
        });
    } else if (currentRequestId === requestIdRef.current) {
      setLoading(false);
    }
  };

  // 表格排序
  const onTableSortChage = (e: SortByItemType) => {
    const newFetchParams = {
      ...newParams,
      order: e?.sortVal,
      order_metric: e?.sortMetric,
      order_type: e?.orderType,
      ratio_type: e?.ratioType ?? 0,
      page: 1,
      page_size: 50,
    };
    setLoading(true);
    setParams(newFetchParams);
  };

  // 表格更换页数量
  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams = {
      ...newParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 50,
    };
    setLoading(true);
    setParams(newFetchParams);
  };

  const jumpGameDetail = (cvm: any) => {
    window.open(
      `/v2/intelligence/topCharts/pcConsoleGames/gamesDetails/${cvm?.combined_id}/overlap`,
    );
  };

  return (
    <div className={classNames('dbh-potential-market-table', className)} style={style}>
      <Tables
        fetchParams={newParams}
        records={data}
        loading={loading}
        tableTotal={total}
        tableSelection={[]}
        tableSelectionAll={[]}
        pageSortAttr={{
          tablePageIndex: newParams?.page,
          tablePageSize: newParams?.page_size,
          currentSortValue: newParams?.order,
          currentSortMetric: newParams?.order_metric,
          currentRatioType: 0,
        }}
        onTableSortChage={onTableSortChage}
        onTablePagingChange={onTablePagingChange}
        onTagClick={onTagClick}
        entityType={'combine'}
        genreSource={'iegg'}
        onClickGame={jumpGameDetail}
        segmentKey={segmentKey}
      />
    </div>
  );
};

export default TableService;
